import { useGetIdentity, useLogout } from "ra-core";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

/**
 * Mobile's only account screen: who is signed in, and sign out. Desktop has
 * the same in its header user menu.
 */
export function MobileAccountPage() {
  const { identity } = useGetIdentity();
  const logout = useLogout();
  return (
    <Card className="m-4 p-4 space-y-4">
      <h1 className="text-xl font-semibold">Account</h1>
      {identity?.fullName ? (
        <p>
          Signed in as <strong>{identity.fullName}</strong>
        </p>
      ) : null}
      <Button variant="outline" onClick={() => logout()}>
        Log out
      </Button>
    </Card>
  );
}

MobileAccountPage.path = "/account";
